function convertRéaumurToCelsius(num) {
  let eq =
    "Converting " + num + "° réaumur to celsius: \n" + num + " * 5 / 4 = ";
  let rep = (num * 5) / 4;
  return eq + rep.toFixed(2);
}

function convertRéaumurToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° réaumur to fahrenheit: \n" +
    num +
    " * 9 / 4 + 32 = ";
  let rep = (num * 9) / 4 + 32;
  return eq + rep.toFixed(2);
}

function convertRéaumurToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° réaumur to kelvin: \n" +
    num +
    " * 5 / 4 + 273.15 = ";
  let rep = (num * 5) / 4 + 273.15;
  return eq + rep.toFixed(3);
}

function convertRéaumurToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° réaumur to rankine: \n" +
    num +
    " * 9 / 4 + 491.67 = ";
  let rep = (num * 9) / 4 + 491.67;
  return eq + rep.toFixed(3);
}

function convertRéaumurToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° réaumur to delisle: \n" +
    "(80 - " +
    num +
    ") * 15 / 8 = ";
  let rep = ((80 - num) * 15) / 8;
  return eq + rep.toFixed(2);
}

function convertRéaumurToNewton(num) {
  let eq =
    "Converting " + num + "° réaumur to newton: \n" + num + " * 33 / 80 = ";
  let rep = (num * 33) / 80;
  return eq + rep.toFixed(2);
}

function convertRéaumurToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° réaumur to rømer: \n" +
    num +
    " * 21 / 32 + 7.5 = ";
  let rep = (num * 21) / 32 + 7.5;
  return eq + rep.toFixed(3);
}

export {
  convertRéaumurToRømer,
  convertRéaumurToNewton,
  convertRéaumurToDelisle,
  convertRéaumurToRankine,
  convertRéaumurToKelvin,
  convertRéaumurToFahrenheit,
  convertRéaumurToCelsius
};
